import React, { useEffect, useState } from 'react'
import { useTranslation } from "react-i18next"
import { Container, Button, Row, Form, Col, FormSelect} from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { addUser } from '../../actions/usersActions'
import Swal from 'sweetalert2'
import Select from "react-select"
import { Link,useNavigate } from 'react-router-dom'

export default function RegisterCandidate() {     
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const {user, resultuser, useractivate} = useSelector(state=>state.users)

    const [formState, setFormState] = useState({})
    const [policy, setPolicy] = useState(false)
    const [password, setPassword] = useState("");
    const [comfirmPassword, setComfirmPassword] = useState("");
    const [isError, setIsError] = useState("");
    const [showPassword, setShowPassword] = useState(false)
    const [showRepeatPassword, setShowRepeatPassword] = useState(false)

    const [catchmentType, setCatchmentType] = useState({
        options: [
            {label: t('users.talktotalk'), value: 'talktotalk'},
            {label: t('users.ad'), value: 'ad'},
            {label: t('users.linkedin'), value: 'linkedin'},
            {label: t('users.instagram'), value: 'instagram'},
            {label: t('users.facebook'), value: 'facebook'},
            {label: t('users.web'), value: 'web'},
            {label: t('users.other'), value: 'other'}
        ],
        selected: {label: t('users.talktotalk'), value: 'talktotalk'}
    })

    const handleSelectCatchmentType = (target) => {
        setCatchmentType({
            ...catchmentType,
            selected: target
        })

        setFormState({
            ...formState,
            'catchment': target.value
        })
    }

    const handleInputChange = ({target})=>{
        setFormState({
            ...formState,
            [target.name]: target.value
        })
    }

    const handlePolicy  = (e) => {
        setPolicy(e.target.checked)
    }

    const handleAdd = async(e) => {
        e.preventDefault()

        dispatch(addUser(formState))
    }

    const checkValidation = (e, position) => {
        const inputPassword = e.target.value;

        if(position === 'first'){
            setPassword(inputPassword)

            if (inputPassword !== comfirmPassword) {
                passwordsDontMatch()
            }else {
                passwordsMatch()
            }
        }else{
            setComfirmPassword(inputPassword)

            if (inputPassword !== password) {
                passwordsDontMatch()
            }else {
                passwordsMatch()
            }
        }
    }

    const passwordsMatch = (e) => {
        setIsError("");
        setFormState({
            ...formState,
            'password': password
        })
    }

    const passwordsDontMatch = (e) => {
        setIsError("Las contraseñas no coinciden");
        setFormState({
            ...formState,
            'password': ''
        })
    }

    useEffect(() => {
        setFormState({
            profile: 'Candidate',
            firstname: '',
            lastname: '',
            phone: '',
            email: '',
            password: '',
            catchment: 'talktotalk',
            marketing: false,
            sex: 'M'
        })
    }, [user, dispatch])

    useEffect(() => {
        if(resultuser){
            switch (resultuser) {
                case 'success':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('users.gotoverify'),
                        icon: 'success',
                        text: t('users.useradd')
                    }).then((resultuser) => {
                        if (resultuser.isConfirmed) {
                            navigate('/activation/'+useractivate)
                        }
                    })
                    break;
                case 'email':
                    Swal.fire({
                        showConfirmButton: true,
                        icon: 'warning',
                        text: t('users.emailduplicate')
                    })
                    break;
                default:
                    break;
            }
        }
    // eslint-disable-next-line
    }, [resultuser])

    return (
        <Container fluid>
            <Row>
                <Col xs={12} className='py-4'>
                    <div id="logotipo-auth" className='text-center text-md-start px-3 pb-5'><Link to="/login"><img src="/images/logotipo-skill.svg" alt="Logotipo skillconnectED" /></Link></div>
                    <Container className='p-0 py-5 p-md-5'>
                        <Row>
                            <Col xs={10} md={8} lg={5} className='text-center mx-auto'>
                                <h1>{t('users.createaccount')}</h1>
                                {t('users.help')}
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={10} md={8} lg={5} className='mx-auto my-3'>    
                                <Form className="formulario" onSubmit={handleAdd}>
                                    <Row>
                                        <Col className='mt-4'>
                                            <h4>{t('profile.candidate.personaldata')}</h4>
                                        </Col>
                                    </Row>
                                    <Row className="my-3">
                                        <Col>
                                            <Form.Label htmlFor='firstname'>{t('users.firstname')}</Form.Label>
                                            <Form.Control
                                                type='text'
                                                name='firstname' 
                                                value={formState.firstname ||  ''}                                                
                                                onChange={handleInputChange}
                                                required
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="my-3">
                                        <Col>
                                            <Form.Label htmlFor='lastname'>{t('users.lastname')}</Form.Label>
                                            <Form.Control
                                                type='text'
                                                name='lastname' 
                                                value={formState.lastname ||  ''}
                                                onChange={handleInputChange}
                                                required
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="my-3">
                                        <Col>
                                            <Form.Label htmlFor='phone'>{t('users.phone')}</Form.Label>
                                            <Form.Control
                                                type='text'
                                                name='phone' 
                                                value={formState.phone ||  ''}
                                                onChange={handleInputChange}
                                                required
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="my-3">
                                        <Col>
                                            <Form.Label>{t('users.howmeetus')}</Form.Label>
                                            <Select
                                                className="form-control select"
                                                onChange={handleSelectCatchmentType}
                                                name="title_type"
                                                options={catchmentType.options}
                                                defaultValue={catchmentType.selected}
                                                required
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="my-3">
                                        <Col>
                                            <Form.Label htmlFor='sex'>{t('users.sex')}</Form.Label>
                                            <FormSelect
                                                name='sex'
                                                value={formState.sex || 'M'}
                                                onChange={handleInputChange}
                                                required
                                            >
                                                <option value="M">{t('users.male')}</option>
                                                <option value="F">{t('users.female')}</option>
                                            </FormSelect>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col className='mt-4'>
                                            <h4>{t('profile.candidate.accountdata')}</h4>
                                        </Col>
                                    </Row>
                                    <Row className="my-3">
                                        <Col>
                                            <Form.Label htmlFor='email'>{t('users.email')}</Form.Label>
                                            <Form.Control
                                                type='email'
                                                name='email' 
                                                value={formState.email ||  ''}
                                                onChange={handleInputChange}
                                                required
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="my-3">
                                        <Col>
                                            <Form.Label htmlFor='password'>{t('users.password')}</Form.Label>
                                            <Form.Control
                                                type={showPassword ? 'text' : 'password'}
                                                name='password' 
                                                onChange={e => checkValidation(e, 'first')}
                                                autoComplete="off"
                                                required
                                            />
                                            <i className={`fas fa-eye${showPassword ? '-slash' : ''} sd-eye`} onClick={() => setShowPassword(!showPassword)}></i>
                                        </Col>
                                    </Row>
                                    <Row className="my-3">
                                        <Col>
                                            <Form.Label htmlFor='confirm_password'>{t('users.repeatPassword')}</Form.Label>
                                            <Form.Control
                                                type={showRepeatPassword ? 'text' : 'password'}
                                                name='confirm_password'
                                                onChange={e => checkValidation(e, 'second')}
                                                autoComplete="off"
                                                required
                                            />
                                            <i className={`fas fa-eye${showRepeatPassword ? '-slash' : ''} sd-eye`} onClick={() => setShowRepeatPassword(!showRepeatPassword)}></i>
                                        </Col>
                                    </Row>
                                    {/* Mostramos si coinciden o no las contraseñas */}
                                    {isError !== ''
                                        ?
                                            <Row className="text-center my-3">
                                                <Col>
                                                    <div className="text-danger">* {t('passwordreset.passwordsdoesnotmatch')} *</div>
                                                </Col>
                                            </Row>
                                        :
                                            <></>
                                    }
                                    <Row>
                                        <Col className='d-flex align-items-start'>
                                            <Form.Check className='float-left pe-3' type='checkbox' name='policy' onChange={handlePolicy} checked={policy || false} />                                
                                            <p className='f'>
                                                {t('users.policy1')}
                                                <a href="https://skillconnected.com/condiciones-de-uso/" target='_blank' rel="noreferrer" className='link'>{t('users.policy2')}</a>
                                                {t('users.policy3')}
                                                <a href="https://skillconnected.com/politica-de-privacidad/" target='_blank' rel="noreferrer" className='link'>{t('users.policy4')}.</a>
                                            </p>
                                        </Col>
                                    </Row>
                                    {/* <Row>
                                        <Col className='d-flex align-items-start'>
                                            <Form.Check className='float-left pe-3' type='checkbox' name='marketing' onChange={handleCheckboxChange} checked={formState.marketing || false} />                            
                                            {t('users.marketing')}
                                        </Col>
                                    </Row> */}
                                    <Row className="text-center my-3">
                                        <Col>
                                            <Button variant='primary' type="submit" className="w-100 my-2" disabled={!policy || isError !== ''}>{t('users.createaccountbutton')}</Button>
                                        </Col>
                                    </Row>
                                </Form>
                            </Col>
                        </Row>
                        <Row className="text-center my-3">
                            <Col>
                                {t('signin.haveaccount')}, <Link to="/login" className='link'>{t('signin.comein')}</Link>
                            </Col>
                        </Row>
                    </Container>
                </Col>
            </Row>
        </Container>
    )
}
